import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: colors.transparentBlack,
    color: colors.white,
    fontSize: 14,
    lineHeight: 1.71,
    fontWeight: 600,
    margin: 0,
    padding: "0px 8px",
    borderRadius: 2,
  },
  button: {
    marginTop: 0,
    padding: 9,
  },
});

export default useStyles;
